import { enqueueToast } from '@/features/toasts/slice'
import { useAppDispatch } from '@/redux/hooks'
import { useSetMediaNonCurrentMutation } from '../api'

export const useSetNonCurrent = () => {
  const dispatch = useAppDispatch()
  const [trigger] = useSetMediaNonCurrentMutation({
    fixedCacheKey: 'set-non-current',
  })

  const setNonCurrent = async (mediaCodes: number[]) => {
    try {
      await trigger(mediaCodes).unwrap()
      dispatch(
        enqueueToast({
          message: `Set ${mediaCodes.length} media item(s) to Non-Current.`,
          severity: 'success',
        }),
      )
    } catch (error) {
      console.error('Failed to set media non-current', error)
      dispatch(
        enqueueToast({
          message: 'Unable to set media to Non-Current.',
          severity: 'error',
        }),
      )
    }
  }

  return { setNonCurrent }
}
